import React from "react";
import classes from "./signup.module.css";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import LinearProgress from "@material-ui/core/LinearProgress";
import SignUpLogo from "../../assets/img/signuplogo.svg";
import TermsAndConditions from "../termsAndConditions/termsAndConditions";
import { createMuiTheme } from "@material-ui/core/styles";
import MuiThemeProvider from "@material-ui/core/styles/MuiThemeProvider";
import { SIGNUP, STUDENT } from "../../utils/url-builder";
import BaseService from "../../store/services/base.service";
import { setTokenOnLogin } from "../../utils/api-authentication";
import queryString from "query-string";
import {
  setInstituteKneuraId,
  setInstituteId,
  setToken,
  setKneuraId,
  setUserId,
  setusername,
  setClassInfo,
  getToken,
  setNotificationToken,
  setUserRole,
  deleteAll
} from "../../utils/authentication-access";
import passwordStrength from "pwd-strength";
import { Mixpanel } from "../../utils/mixpanel";
import { withTranslation } from "react-i18next";
import { WEBSITE_URL } from "../../config";

class SignUp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      password: "",
      confirmpassword: "",
      email: "",
      readdialogopen: false,
      readterm: false,
      showloader: false
    };
  }

  componentDidMount() {
    deleteAll();
    const values = queryString.parse(this.props.location.search);
    if (values.email && values.vid) {
      this.setState({ email: values.email });
      this.verifyRegisterCode(values.email, values.vid);
    } else {
      this.props.history.push("/forgotpassword");
    }
  }

  verifyRegisterCode = async (email, token) => {
    let self = this;
    const url = SIGNUP.verifyRegisterCode();

    try {
      this.setState({ showloader: true });
      await new BaseService().makePostRequestGenericWithoutLoader(url, {
        email: email,
        vid: token,
        role: "learner"
      });
      this.setState({ showloader: false });
    } catch (error) {
      this.setState({ showloader: false });
    }
  };

  onPasswordEnter(event) {
    this.setState({
      password: event.target.value,
      passworderrorText: "",
      passworderrorstatus: false
    });
  }

  onConfirmPasswordEnter(event) {
    this.setState({
      confirmpassword: event.target.value,
      confirmpassworderrorText: "",
      confirmpassworderrorstatus: false
    });
  }

  onEnterKeyPress = (e) => {
    if (e.key === "Enter") {
      this.signUpClick();
    }
  };

  loginClick = () => {
    window.location.replace(WEBSITE_URL);
  };

  accept = () => {
    this.setState({ acceptAgreement: !this.state.acceptAgreement });
    this.setState({ readterm: false });
  };

  readClick = () => {
    this.setState({ readdialogopen: true });
  };

  readDialogClose = () => {
    this.setState({ readdialogopen: false });
  };

  toggleTermsPage = () => {
    this.setState((prevState) => ({
      readdialogopen: !prevState.readdialogopen
    }));
  };

  signUpClick = async () => {
    if (this.state.password === "") {
      this.setState({ passworderrorstatus: true });
      this.setState({ passworderrorText: "Enter Password" });
    } else if (this.state.password.length < 8) {
      this.setState({ passworderrorstatus: true });
      this.setState({ passworderrorText: "Password too short." });
    } else if (
      !passwordStrength(this.state.password, {
        minUpperChars: 1,
        minLowerChars: 1,
        minSpecialChars: 1
      }).success
    ) {
      let errorMsg = passwordStrength(this.state.password, {
        minUpperChars: 1,
        minLowerChars: 1,
        minSpecialChars: 1
      }).message;
      this.setState({ passworderrorstatus: true });
      this.setState({ passworderrorText: errorMsg });
    } else if (!passwordStrength(this.state.password).success) {
      this.setState({ passworderrorstatus: true });
      this.setState({
        passworderrorText: "Password is not safe. Please try another password"
      });
    } else if (this.state.confirmpassword === "") {
      this.setState({ confirmpassworderrorstatus: true });
      this.setState({ confirmpassworderrorText: "Enter Confirm Password" });
    } else if (this.state.confirmpassword !== this.state.password) {
      this.setState({ confirmpassworderrorstatus: true });
      this.setState({ confirmpassworderrorText: "Password Mismatch" });
    } else if (!this.state.acceptAgreement) {
      this.setState({
        errmsg: "Please agree to the terms & policy before continuing"
      });
      this.setState({ openerrmsg: true, readterm: true });
    } else {
      const url = SIGNUP.signUp();
      try {
        this.setState({ showloader: true });
        let res = await new BaseService().makePostRequestGenericWithoutLoader(
          url,
          {
            email: this.state.email,
            password: this.state.password
          }
        );
        Mixpanel.people.set({
          $first_name: res.data.first_name,
          $email: this.state.email
        });
        Mixpanel.identify(res.data.kneura_id);
        Mixpanel.track("Successful signup");
        this.setState({ showloader: false });
        this.setState({ data: res.data });
        setKneuraId(res.data.kneura_id);
        setUserId(res.data.userId);
        setInstituteKneuraId(res.data.instituteKneuraId);
        setInstituteId(res.data.instituteId);
        setToken(res.data.access_token);
        setTokenOnLogin(res.data.access_token);
        setusername(res.data.first_name);
        setNotificationToken(res.data.notificationToken);
        setUserRole(res.data.userRoles);

        this.getAllClasses(res.data.kneura_id, res.data.instituteKneuraId);
      } catch (error) {
        this.setState({ showloader: false });
        Mixpanel.track("Unsuccessful signup");
      }
    }
  };

  getAllClasses = async (user_id, Inst_id) => {
    const url = STUDENT.getStudentClass();
    try {
      this.setState({ showloader: true });
      let res = await new BaseService().makeGetRequestGenericWithoutLoader(
        url,
        {
          access_token: getToken(),
          "Content-Type": "application/json",
          role: "learner",
          user_kneura_id: user_id,
          institute_kneura_id: Inst_id
        }
      );
      if (res.data.length > 0) {
        setClassInfo(res.data[0]);
      }
      this.setState({ showloader: false });
      this.props.history.push("/dashboard");
    } catch (error) {
      this.setState({ showloader: false });
    }
  };

  render() {
    const { t } = this.props;
    return (
      <MuiThemeProvider theme={theme}>
        {this.state.showloader ? (
          <LinearProgress
            style={{
              position: "absolute",
              zIndex: "100",
              width: "100%",
              top: "0"
            }}
          />
        ) : (
          ""
        )}
        <div className={classes.mainGrid}>
          <div className={classes.backGroungImg}></div>
          <div className={classes.logoGrid} onClick={this.loginClick}>
            <Grid
              container
              direction="column"
              justify="center"
              alignItems="center"
            >
              <img
                className={classes.logoImage}
                src={SignUpLogo}
                alt="signup logo"
              />
            </Grid>
          </div>
          <div className={classes.signupgrid}>
            <Grid
              container
              direction="column"
              justify="flex-start"
              alignItems="center"
            >
              <Paper className={classes.signup} elevation={3}>
                <div className={classes.subGrid}>
                  <div className={classes.title}>{t("Welcome to Kneura")}</div>
                  <div className={classes.subtitle}>
                    {t("Create your Kneura ID to proceed")}.
                  </div>

                  <TextField
                    id="email-address"
                    label="Email address"
                    className="input-field"
                    margin="normal"
                    value={this.state.email}
                    FormHelperTextProps={fixHyperText}
                    // helperText={this.state.emailerrorText}
                    // error={this.state.emailerrorstatus}
                    // onChange={this.onEmailEnter.bind(this)}
                    // onKeyDown={this.onEnterKeyPress}
                    disabled
                  />
                  <TextField
                    type="password"
                    ref="password"
                    id="password"
                    label="Password"
                    className="input-field"
                    margin="normal"
                    value={this.state.password}
                    FormHelperTextProps={fixHyperText}
                    helperText={this.state.passworderrorText}
                    error={this.state.passworderrorstatus}
                    onChange={this.onPasswordEnter.bind(this)}
                    onKeyDown={this.onEnterKeyPress}
                  />
                  <TextField
                    type="password"
                    ref="password"
                    id="confirm-password"
                    label="Confirm Password"
                    className="input-field"
                    margin="normal"
                    value={this.state.confirmpassword}
                    FormHelperTextProps={fixHyperText}
                    helperText={this.state.confirmpassworderrorText}
                    error={this.state.confirmpassworderrorstatus}
                    onChange={this.onConfirmPasswordEnter.bind(this)}
                    onKeyDown={this.onEnterKeyPress}
                  />
                  <div className={classes.terms}>
                    <div
                      className={
                        this.state.readterm ? "link-errortext" : "link-text"
                      }
                    >
                      <input
                        defaultChecked={this.state.acceptAgreement}
                        type="checkbox"
                        onChange={this.accept}
                      />{" "}
                      <span
                        className="tnchover"
                        style={{ textDecoration: "underline" }}
                        onClick={this.readClick}
                      >
                        {t("I agree to the terms and policy")}.
                      </span>{" "}
                    </div>
                  </div>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    size="large"
                    style={{ textTransform: "capitalize" }}
                    onClick={this.signUpClick}
                    disableElevation
                  >
                    {t("Create account")}
                  </Button>
                  <div className={classes.logintext} onClick={this.loginClick}>
                    {t("Already have an account")}?{" "}
                    <span style={{ color: "#0074E4" }}>{t("Login")} ></span>
                  </div>
                </div>
              </Paper>
            </Grid>
          </div>
          <Snackbar
            message={this.state.errmsg}
            open={this.state.openerrmsg}
            onClose={() => this.setState({ openerrmsg: false })}
            autoHideDuration={2000}
          />
          <TermsAndConditions
            open={this.state.readdialogopen}
            termsPageClose={() => this.toggleTermsPage()}
          />
        </div>
      </MuiThemeProvider>
    );
  }
}

const fixHyperText = {
  style: {
    position: "absolute",
    bottom: "-40%"
  }
};

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#0074E4"
    }
  }
});

export default withTranslation()(SignUp);
